const URL_RENDER_V1 = "https://zapiszto-service.onrender.com/v1";
const URL_LOCALHOST = "http://localhost:8080"
const URL_LOCALHOST_V1 = "http://localhost:8080/v1"
const URL_AUTH_LOCALHOST = "http://localhost:8080/api/auth/";
const URL_AUTH_RENDER = "https://zapiszto-service.onrender.com/api/auth/";
const RECAPTHCA_LOCALHOST = '6LfpUvgpAAAAAH4mqrcWNgVcavvJCLDjN6Tr2Arv'
                        
export const RECAPTCHA_SITE_KEY = RECAPTHCA_LOCALHOST


//-- localhost --
// export const API_URL = URL_LOCALHOST_V1;
// export const AUTH_URL = URL_AUTH_LOCALHOST;
// export const URL_BASE = URL_LOCALHOST;
  
//--- produkcja ---
export const API_URL = "https://zapiszto-service.onrender.com/v1";
export const AUTH_URL = "https://zapiszto-service.onrender.com/api/auth/";
export const URL_BASE = "https://zapiszto-service.onrender.com";